import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { UserCheck } from "lucide-react";

export function ContactTeacherPicker({ student, canEdit, onChange }) {
  const [teachers, setTeachers] = useState([]);
  const [branches, setBranches] = useState({});
  useEffect(() => {
    if (!canEdit) return;
    api.get("/staff-mgmt/staff", { params: { role: "teacher" } }).then((r) => {
      const list = r.data.filter((u) => u.role === "teacher");
      list.sort((a, b) => (a.branch_id === student.branch_id ? 0 : 1) - (b.branch_id === student.branch_id ? 0 : 1) || a.name.localeCompare(b.name));
      setTeachers(list);
    }).catch(() => {});
    api.get("/branches").then((r) => setBranches(Object.fromEntries(r.data.map((b) => [b.id, b.name])))).catch(() => {});
  }, [canEdit, student.branch_id]);
  async function pick(v) {
    try {
      const r = await api.post(`/student-contact-teacher/${student.id}`, { teacher_id: v === "none" ? null : v });
      toast.success(r.data.contact_teacher_name ? `${r.data.contact_teacher_name} is now the contact teacher` : "Contact teacher removed");
      onChange(r.data);
    } catch (e) { toast.error(formatApiError(e)); }
  }
  return (
    <div data-testid="contact-teacher" className="rounded-xl border border-violet-100 bg-violet-50/50 p-3 flex flex-wrap items-center gap-3 mt-3">
      <UserCheck size={16} className="text-violet-700" />
      <div className="flex-1 min-w-[160px]">
        <div className="text-xs text-slate-500">Contact teacher for parents</div>
        <div className="text-sm font-semibold text-slate-800" data-testid="contact-teacher-name">{student.contact_teacher_name || "Not assigned"}</div>
      </div>
      {canEdit && (
        <Select value={student.contact_teacher_id || "none"} onValueChange={pick}>
          <SelectTrigger data-testid="contact-teacher-select" className="w-72 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No contact teacher</SelectItem>
            {teachers.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}{t.designation ? ` · ${t.designation}` : ""}{t.assigned_class ? ` · ${t.assigned_class}` : ""}{t.branch_id !== student.branch_id ? ` (${branches[t.branch_id] || "other branch"})` : ""}</SelectItem>)}
            {teachers.length === 0 && <div className="px-3 py-2 text-xs text-slate-500">No teachers yet. Add them in Staff Management.</div>}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
